import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=107ae268&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/chat.css?vue&type=style&index=0&id=107ae268&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ae268",
  null
  
)

export default component.exports